export default {
    button: {
        back: 'Back to the work space'
    },
    title: 'Search agent',
    pageTitle: 'VIEW - SEARCHAGENT'
}
